export default __webpack_public_path__ + "static/media/Facepay.a44b03b6.png";